import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

export const getAllLeads = createAsyncThunk(
  "Lead/FindAllLead",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Lead/FindAllLead`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Leads:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createLead = createAsyncThunk(
  "Lead/InsertLead",
  async (LeadData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Lead/InsertLead`,
        LeadData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Lead:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateLead = createAsyncThunk(
  "Lead/UpdateLead",
  async (LeadData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Lead/UpdateLead`,
        LeadData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Lead:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteLead = createAsyncThunk(
  "Lead/DeleteLead",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Lead/DeleteLead`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Lead", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getLeadByID = createAsyncThunk(
  "Lead/FindByIDLead",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Lead/FindByIDLead`,
        { ID },
      );

      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        Initial: result?.Initial,
        FirstName: result?.FirstName,
        LastName: result?.LastName,
        CountryCode: result?.CountryCode,
        MobileNo: result?.MobileNo,
        EmailID: result?.EmailID,
        LeadType: result?.LeadType,
        LeadSourceID: result?.LeadSourceID,
        SectorID: result?.SectorID,
        LeadStageID: result?.LeadStageID,
        City: result?.City,
      } as any;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Lead:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const assignLeadToUser = createAsyncThunk(
  "AssignedUser/LeadAssignedUsers",
  async (LeadData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AssignedUser/LeadAssignedUsers`,
        LeadData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Lead:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateLeadStageStatus = createAsyncThunk(
  "Lead/UpdateStatusLeadStage",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Lead/UpdateStatusLeadStage`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating lead status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const bulkUploadLeads = createAsyncThunk(
  "Lead/ManageLeadBulkUpload",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Lead/ManageLeadBulkUpload`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error uploading contacts:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getLeadAssignUserHistory = createAsyncThunk(
  "AssignedUser/LeadAssignHistory",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AssignedUser/LeadAssignHistory`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Assign User History:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllAdNames = createAsyncThunk(
  "Lead/GetAdNameFromDropdown",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Lead/GetAdNameFromDropdown`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Ad Names:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const downloadLeadExcel = createAsyncThunk(
  "Lead/ExcelForLeads",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Lead/ExcelForLeads`,
        formData,
        { responseType: "arraybuffer" },
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Downloading Leads:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
